import React from 'react';

function DashboardIcon({ iconClass }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" stroke='currentColor' strokeWidth={1} width='1em' height='1em' viewBox="0 0 44.43 44.43" className={iconClass}><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" width="19.55" height="19.55" rx="4.6" /><rect class="cls-1" x="24.88" width="19.55" height="19.55" rx="4.6" /><rect class="cls-1" y="24.88" width="19.55" height="19.55" rx="4.6" /><rect class="cls-1" x="24.88" y="24.88" width="19.55" height="19.55" rx="4.6" /></g></g></svg>
    );
}

export default DashboardIcon;